import React, { useState, useRef, useEffect } from "react";
import CompanyLogo from "../../../../assets/img/logos/dicelogoTransparent_01.png";
import background from "../../../../assets/img/logos/Tag_template.jpg";
import QrCodes from "../appComponents/QrCodes";
import BarCode from "../appComponents/BarCode";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const StaffIDCard = (props) => {
  const [itemValues, setItemValues] = useState([]);
  const [itemReferenceNo, setItemReferenceNo] = useState("");
  const QrCodeRef = useRef(null);

  useEffect(() => {
    setItemValues(props.itemValues || []);
    setItemReferenceNo(props.itemReferenceNo || "");
  }, [props.itemValues, props.itemReferenceNo]);

  const styles = {
    background: {
      backgroundImage: `url(${background})`,
      height: "100%",
      width: "96%",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      display: "block",
      position: "relative",
      zIndex: 0,
    },
    qrCode: {
      marginLeft: "250px",
      paddingTop: "275px",
      position: "absolute",
      zIndex: "10",
    },
    returnInfo: {
      fontSize: "14px",
      padding: "10px 15px",
      textAlign: "center",
    },
    barcodeContainer: {
      paddingTop: "10px",
    },
    qrCodePositioning: {
      paddingLeft: "20%",
    },
  };

  let type = "STAFF";
  if (itemValues.authority === 1) {
    type = "DESK OFF.";
  } else if (itemValues.authority === 2) {
    type = "WEB ADMIN";
  } else if (itemValues.authority === 3) {
    type = "ADMIN";
  } else if (itemValues.authority === 4) {
    type = "FULL ADMIN";
  }

  return (
    <>
      <table
        ref={QrCodeRef}
        width="510"
        border="1"
        align="left"
        cellpadding="0"
        cellspacing="0"
        height="367"
      >
        {itemReferenceNo && (
          <div style={styles.qrCode}>
            <QrCodes addrurl={itemReferenceNo} qrcodeSize={"78px"} />
          </div>
        )}
        <tr>
          <td>
            {/* Request QRCODE */}

            {/* End of Request QRCODE */}

            <table width="255" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td align="center" height="10">
                  <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                  >
                    <tr>
                      <td width="20%" align="rigth">
                        &nbsp;
                      </td>
                      <td width="80%" align="center"></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="5"
                  >
                    <tr>
                      <td align="center">
                        <strong style={{ fontSize: "14px", color: "#000" }}>
                          Company ID Card
                        </strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    border="0"
                    align="center"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td>
                        {itemReferenceNo && (
                          <div style={styles.qrCodePositioning}>
                            <QrCodes
                              addrurl={itemReferenceNo}
                              qrcodeSize={"120px"}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td style={styles.returnInfo}>
                        Please return if found to <br />
                        FEDERAL MINISTRY OF HOUSING AND URBAN DEVELOPMENT
                        <br />
                        <em style={{ fontSize: "14px", color: "#FF0000" }}>
                          {" "}
                          Headquarters, Mabushi, Abuja
                        </em>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td>
            <table
              width="255"
              border="0"
              cellspacing="0"
              cellpadding="0"
              style={styles.background}
            >
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    style={{ marginTop: "4px" }}
                  >
                    <tr>
                      <td width="26%" align="rigth">
                        <img
                          name=""
                          src={CompanyLogo}
                          width="45"
                          style={{ paddingLeft: "7px", paddingTop: "10px" }}
                          alt=""
                        />
                      </td>
                      <td
                        width="74%"
                        align="left"
                        valign="top"
                        style={{
                          fontSize: "13px",
                          color: "#FFF",
                          paddingTop: "15px",
                          paddingLeft: "0px",
                          marginLeft: "0px",
                        }}
                      >
                        <strong
                          style={{
                            paddingLeft: "0px",
                            marginLeft: "-7px",
                          }}
                        >
                          WEBDYNAMO ATTENDANCE
                        </strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td
                        width="100%"
                        align="center"
                        style={{
                          fontSize: "9px",
                          color: "#FF0000",
                          padding: "12px 10px 8px 10px",
                        }}
                      >
                        <em>
                          <b>
                            Headquarters, Mabushi, Abuja Tel: +234-(0)- 8 061
                            7433 13, www.fmhud.gov.ng FCT
                          </b>
                        </em>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    align="center"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td
                        align="center"
                        style={{ padding: "0px 20px 3px 20px" }}
                      >
                        <img
                          name="2"
                          src={
                            BACKEND_URL + itemValues.passport ??
                            BACKEND_URL +
                              "upload/admin_passports/emptyImage.jpg"
                          }
                          width="100"
                          height="120"
                          alt=""
                        />
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <strong
                    style={{
                      fontSize: "16px",
                      color: "#000",
                    }}
                  >
                    {itemValues.name}
                  </strong>
                </td>
              </tr>

              <tr>
                <td
                  align="center"
                  style={{
                    fontSize: "12px",
                    color: "#FF0000",
                    paddingBottom: "10px",
                  }}
                >
                  <strong>STAFF No.:- {itemValues.fileNumber}</strong>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style={{ fontSize: "12px", color: "#fff" }}
                  >
                    <tr>
                      <td width="42%">&nbsp;</td>
                      <td width="58%">
                        <strong>
                          Gender:-{" "}
                          <div className="text-uppercase d-inline">
                            {itemValues.sex}
                          </div>
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>
                        <strong>Access:- {type}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>
                        <strong>Valid Till:- {itemValues.validity}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td style={styles.barcodeContainer}>
                        <BarCode
                          barcodeValuess={itemValues.fileNumber}
                          barcodeHeights="15"
                          barcodeWidths="1"
                          barcodeFontSizes="12"
                          displayValues="false"
                        />
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </>
  );
};
export default StaffIDCard;
